export default class OrcamentoItem {
  constructor(id, codigo, descricao, quantidade, unidade, valor, total) {
    this.id = id;
    this.codigo = codigo;
    this.descricao = descricao;
    this.quantidade = quantidade;
    this.unidade = unidade;
    this.valor = valor;
    this.total = total;
  }

  calcularTotal() {
    var calculo = 0.0;
    calculo =
      Number(this.quantidade) *
      Number(this.valor.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
    calculo = parseFloat(calculo).toFixed(2);
    var inteira = calculo.substr(0, calculo.length - 3);
    var ajuste = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decimal = calculo.substr(calculo.length - 3, calculo.length);
    decimal = decimal.replace(".", ",");
    this.total = "R$ " + ajuste + decimal;
  }

  getTotalNumber() {
    return Number(this.total.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
  }
}
